/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VirtualContainerData } from '../../models/virtual-container-data';

export interface GetSecondaryVirtualContainerData$Params {
  ssccCode: string;
}

export function getSecondaryVirtualContainerData(http: HttpClient, rootUrl: string, params: GetSecondaryVirtualContainerData$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualContainerData>> {
  const rb = new RequestBuilder(rootUrl, getSecondaryVirtualContainerData.PATH, 'get');
  if (params) {
    rb.path('ssccCode', params.ssccCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualContainerData>;
    })
  );
}

getSecondaryVirtualContainerData.PATH = '/api/v1/SecondaryMaterial/virtualContainer/{ssccCode}';
